import React, { useEffect, useState } from 'react';
import { getRecordById } from '../../../localDB';
import config from '../../../config.json';

const OpalCyclePeriodVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {

    const c_code = localStorage.getItem("c_cd") || "";
    const c_str = localStorage.getItem("c_str") || "";
    const c_end = localStorage.getItem("c_end") || "";


    function formatToMonthDay(dateString) {
        if (!dateString) return '';

        const date = new Date(dateString);
        if (isNaN(date)) return ''; // handle invalid date

        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric'
        }).toUpperCase(); // Output: "APR 1"
    }


    return (
        <div className='chart-content'>
            <div className='d-flex align-items-center justify-content-between h-100'
                style={{
                    fontFamily: 'Lato-Regular'
                }}>
                <div style={{ fontFamily: "Lato-semibold", fontSize: "3rem" }}>{c_code}</div>
                <div style={{ fontSize: "1rem" }}>
                    {formatToMonthDay(c_str)}
                    <span className='mx-1'>to</span>
                    {formatToMonthDay(c_end)}
                </div>
            </div>
        </div>
    );
};

export default OpalCyclePeriodVisual;
